import { Avatar, Box, ButtonBase, Typography } from "@mui/material";
import { ROUTES } from "constants/routes";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "store/appHooks";
import { getConversationId } from "utils/messages.util";

const ListingOwner = ({ user }: any) => {
  const listingOwner = user;
  const { authReducer } = useAppSelector((state) => state);
  const navigate = useNavigate();

  const gotoMessaging = async () => {
    if (!authReducer.isLoggedIn) return navigate(ROUTES.SIGNIN);

    const convId = await getConversationId(user?.firebase_id, user?.name);
    if (convId) navigate(ROUTES.MESSAGES.replace(":id", convId ?? "null"));
    else
      navigate(
        `${ROUTES.MESSAGES.replace(":id", "new")}?user=${user?.name}&fbId=${
          user?.firebase_id
        }&img=${encodeURIComponent(user?.image_url)}`
      );
  };

  return (
    <Box
      sx={{
        px: { md: "2%", lg: "2%", xl: "2%", sm: "4%", xs: "4%" },
        py: "0px",
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "18px",
          lineHeight: "31px",
          mt: "20px",
          mb: "10px",
        }}
      >
        Owner
      </Typography>

      <Box
        sx={{
          background: "#EAF2FF",
          my: "15px",
          padding: "20px",
          borderRadius: "10px",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", gap: "15px", alignItems: "center" }}>
            <Avatar
              src={listingOwner?.image_url}
              sx={{
                img: { width: "65px", height: "65px" },
                width: "65px",
                height: "65px",
              }}
            />
            <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <Typography
                sx={{
                  color: "#323232",
                  fontSize: "18px",
                  fontWeight: 600,
                  lineHeight: "14px",
                }}
              >
                {listingOwner?.name}
              </Typography>
              <Typography
                sx={{
                  color: "#323232",
                  fontSize: "13px",
                  fontWeight: 400,
                  lineHeight: "14px",
                }}
              >
                Joined in {moment(listingOwner?.created_at).format("MMM yyyy")}
              </Typography>
            </Box>
          </Box>
          <ButtonBase
            sx={{
              background: "#307AFF",
              width: {
                md: "160px",
                lg: "160px",
                xl: "160px",
                sm: "48px",
                xs: "48px",
              },
              height: {
                md: "56px",
                lg: "56px",
                xl: "56px",
                sm: "48px",
                xs: "48px",
              },
              display: "flex",
              justifyContent: "center",
              alignItems: "center",

              color: "#FFF",
              borderRadius: "10px",
            }}
            onClick={gotoMessaging}
          >
            <Typography
              sx={{
                display: {
                  md: "block",
                  lg: "block",
                  xl: "block",
                  sm: "none",
                  xs: "none",
                },
              }}
              color="#FFF"
              fontSize="15px"
            >
              Message Owner
            </Typography>

            <Box
              sx={{
                display: {
                  md: "none",
                  lg: "none",
                  xl: "none",
                  sm: "block",
                  xs: "block",
                },
              }}
              color="#FFF"
              fontSize="15px"
            >
              <img src="/assets/img/icons/message.svg" alt="" />
            </Box>
          </ButtonBase>
        </Box>

        <Typography
          sx={{
            color: "#323232",
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: 400,
            mt: "15px",
          }}
        >
          As a dedicated tractor owner, I bring expertise in agricultural
          machinery, ensuring top-notch performance for your farming needs.
        </Typography>
      </Box>
    </Box>
  );
};

export default ListingOwner;
